// Set a cookie
export const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date();
  expires.setDate(expires.getDate() + days);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()}`;
};

// Get a cookie
export const getCookie = (name: string) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
}

// Remove a cookie
export const removeCookie = (name: string) => {
  const pathBits = window.location.pathname.split('/');
  let pathCurrent = ' path=';

  // Iterate over paths
  for (let i = 0; i < pathBits.length; i++) {
      pathCurrent += (pathCurrent.substring(-1) !== '/' ? '/' : '') + pathBits[i];
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;${pathCurrent};`;

      // Attempt to remove cookie with domain and without domain
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;${pathCurrent}; domain=${window.location.hostname};`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;${pathCurrent}; domain=.${window.location.hostname};`;
  }
};